import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API } from "@/contexts/AuthContext";
import { AuthShell, TextField } from "@/pages/Login";
import { EnvelopeSimple, CheckCircle } from "@phosphor-icons/react";

export default function PasswortVergessenPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/auth/password-reset/request`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Etwas ist schiefgelaufen. Bitte später erneut versuchen.");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <AuthShell>
        <div className="text-center" data-testid="password-reset-request-sent">
          <div className="w-14 h-14 rounded-full bg-forest-50 border border-forest-100 flex items-center justify-center mx-auto mb-5">
            <CheckCircle size={30} weight="duotone" className="text-forest-700" />
          </div>
          <h1 className="font-heading text-2xl sm:text-3xl font-semibold text-forest-900">
            E-Mail versendet
          </h1>
          <p className="mt-3 font-body text-[15px] text-[#4A524C]">
            Falls es einen Plantus-Account mit dieser Adresse gibt, findest du in Kürze
            eine E-Mail mit einem Link, um dein Passwort zurückzusetzen. Der Link ist
            <strong> 60 Minuten </strong>gültig.
          </p>
          <p className="mt-2 font-body text-sm text-[#7A827C]">
            Nichts erhalten? Schau bitte auch im Spam-Ordner nach.
          </p>
          <Link
            to="/login"
            className="mt-6 inline-block font-body text-sm text-forest-700 hover:underline font-medium"
          >
            ← Zurück zum Login
          </Link>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell>
      <h1 className="font-heading text-3xl sm:text-4xl font-semibold text-forest-900">
        Passwort vergessen?
      </h1>
      <p className="mt-2 font-body text-[15px] text-[#4A524C]">
        Gib deine E-Mail-Adresse ein. Wir senden dir einen Link, um dein Passwort
        zurückzusetzen.
      </p>

      <form onSubmit={onSubmit} data-testid="password-reset-request-form" className="mt-8 space-y-5">
        <TextField
          label="E-Mail"
          name="email"
          type="email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          testId="password-reset-email-input"
        />
        {error && (
          <div
            data-testid="password-reset-error"
            className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2"
          >
            {error}
          </div>
        )}
        <button
          type="submit"
          disabled={loading}
          data-testid="password-reset-request-submit"
          className="w-full inline-flex items-center justify-center gap-2 bg-forest-600 hover:bg-forest-700 disabled:opacity-60 text-white font-heading font-medium px-6 py-3 rounded-xl transition-all shadow-sm hover:shadow-md hover:-translate-y-0.5"
        >
          <EnvelopeSimple size={18} weight="bold" />
          {loading ? "Sende …" : "Link anfordern"}
        </button>
      </form>

      <p className="mt-7 font-body text-sm text-[#4A524C]">
        <Link
          to="/login"
          className="text-forest-700 font-medium hover:underline"
        >
          ← Zurück zum Login
        </Link>
      </p>
    </AuthShell>
  );
}
